import { render, staticRenderFns } from "./RolesIndex.vue?vue&type=template&id=7bfcd087&scoped=true"
import script from "./RolesIndex.vue?vue&type=script&lang=js"
export * from "./RolesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfcd087",
  null
  
)

export default component.exports